<template>


  <div id="app">
    <!-- <scale-box :width="1920" :height="1080" mode="fit">
    </scale-box> -->
    <!-- <v-scale-screen :fullScreen="true" height="1080" width="1920" ref="scaleScreenRef" mode="min"> -->
    <!-- 你的页面内容 -->
    <router-view />
    <!-- </v-scale-screen> -->
  </div>
</template>
<script>
import './assets/font/font.css'
export default {
  name: 'LufeidemoApp',
  data() {
    return {

    };
  },
  beforeMount() {
  },
  mounted() {
  },

  methods: {
  },
};
</script>
<style lang="less">
#app {
  /* min-width: 1200px; */
  width: 100%;
  height: 100%;
  min-height: 100%;
  min-width: 1400px !important;

  // background-color: red;
  overflow: hidden;
  overflow-y: hidden;

}

.AlimamaFangYuanTiVF {
  font-family: AlimamaFangYuanTiVF;
}

.DIN-BoldItalic {
  font-family: DIN-BoldItalic;
}

.SourceHanSansCN-Bold {
  font-family: SourceHanSansCN-Bold;
}

.SourceHanSansCN-Regular {
  font-family: SourceHanSansCN-Regular;
}

.OPPOSans-B {
  font-family: OPPOSans-B;

}

.OPPOSans-R {
  font-family: OPPOSans-R;

}

.ngs_class {
  font-size: 15px !important;
}

.el-menu--popup {
  opacity: .9 !important;
}



.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  height: 50px;
  line-height: 50px;
}

.product-features-content {
  ol {
    list-style: none;

    li {
      text-indent: 20px !important;
      font-weight: 400;
      font-size: 16px;
      color: #222222;
      line-height: 50px;

    }
  }
}

// 新闻详情
.news_details_content {
  p {
    font-family: SourceHanSansCN-Regular;
    font-size: 18px !important;

    img {
      width: 60%;
      height: 60%;
      margin: 0 auto;
    }
  }
}
</style>